import React from 'react';
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";


export default class ModalAgrupamento extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            polo_agrupador: null,
        }
    }

    async componentDidMount() {

    }

    render() {

        return (<>
            <Dialog
                header="Agrupar Polos Geradores"
                visible={this.props.show}
                style={{width: '50vw', marginTop: '50px'}}
                onHide={this.props.handleClose}
                blockScroll={true}
            >

                <div className="card">
                    <div className="card-body">
                        <div className="form-group row">
                            <div className="col-12">
                                <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                    <label htmlFor="">Selecione o Polo Agrupador</label> <br/>
                                    <Dropdown
                                        value={this.state.polo_agrupador}
                                        onChange={(e) => {
                                            this.setState({polo_agrupador: e.value})
                                        }}
                                        style={{width: '100%'}}
                                        options={this.props.polos_para_agrupamento}
                                        optionLabel="title"
                                        placeholder="Selecione o Polo Agrupador"
                                        className="w-full md:w-14rem"
                                        checkmark={true}
                                        highlightOnSelect={true}
                                        filter={true}
                                        filterBy="title"
                                        appendTo={document.body}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-6">
                                <button className="btn btn-danger btn-sm btn-block"
                                        onClick={(event)=>{
                                            event.preventDefault();

                                            this.props.handleSave(this.state.polo_agrupador);

                                        }}>Confirmar
                                </button>
                            </div>
                            <div className="col-6">
                                <button className="btn btn-default btn-sm btn-block"
                                        onClick={this.props.handleClose}>Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>);
    }
}
const styles = {
    legend: {
        padding: '5px',
        margin: '4px',
    }
}
